import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {TheBorderGameMode} from "./server/TheBorderGameMode";
import {TheBorder} from "./TheBorder";
import {TheBorderSound} from "./sound/TheBorderSound";



export class TheBorderPromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy:boolean = false;

    constructor() {
    }

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName:"The Border",
            hasActionSpin:true,
            mainGame:{
                header:() => TheBorder.apiPlugin.translations.translate("xBET"),
                options:[
                    {name:"NORMAL", id:0, image:"NORMAL.png"},
                    {name:"BOOSTED_BET", id:1, image:"BOOSTED_BET.png"}
                ],
                type:ASMainGamePickOptions.BOOSTED_BET
            },
            graphics:{backgroundTextureName:"introBg"},
            getParsedData:(response:any, bet:number, prevResponse:any):ASWinData => {
                if (response.mode === TheBorderGameMode.NORMAL){
                    this.wasFeatureBuy = response.wasFeatureBuy;
                }
                const parsedData:ASWinData = {
                    totalWin:response.accumulatedRoundWin,
                    totalSpinWinnings:this.getWin(response, bet, prevResponse),
                    wasFeatureBuy:response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin:this.isFreeSpinTriggered(response),
                    isBigWin:this.isBigWin(response),
                    winType:WINTYPE.NORMAL,
                    featureName:this.getFeatureName(response),
                    isRoundComplete:this.isRoundComplete(response),
                    isBonusEnd:this.isBonusEnd(response),
                    isWinCapHit:response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any):boolean {
        const win = response.totalSpinRoundWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio:number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (this.wasFeatureBuy) {
            const betPrice = TheBorder.getBuyFeaturePrice();
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response:any, bet:number, prevData:any):number {
        return response.totalSpinRoundWinnings;
    }

    private getFeatureName(response:any):string {

        if (response.mode == TheBorderGameMode.FREESPIN || response.nextMode == TheBorderGameMode.FREESPIN || response.mode == TheBorderGameMode.FREESPIN_AVALANCHE || response.nextMode == TheBorderGameMode.FREESPIN_AVALANCHE){
            return "MULE SPINS"
        }

        if (response.mode == TheBorderGameMode.SUPER_FREESPIN || response.nextMode == TheBorderGameMode.SUPER_FREESPIN || response.mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE || response.nextMode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE){
            return "COYOTE SPINS"
        }

        return "";
    }

    private isFreeSpinTriggered(response:any):boolean {
        return response.freespinTriggeredThisSpin && response.nextMode !== TheBorderGameMode.NORMAL && !response.brokeBank;
    }

    private isRoundComplete(response:any):boolean {
        return ([TheBorderGameMode.NORMAL, TheBorderGameMode.FREESPIN_SUPER, TheBorderGameMode.FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:any):boolean {
        return response.nextMode === TheBorderGameMode.NORMAL && (response.mode.indexOf("NORMAL") === -1);
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN) {
            TheBorder.soundPlayer.playSound(TheBorderSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            TheBorder.soundPlayer.playSound(TheBorderSound.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data:any):void {
        TheBorder.keypadPlugin.hide();
        TheBorder.model.onGame(data);
        TheBorder.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        TheBorder.keypadPlugin.setWin(data.accumulatedRoundWin, true, TheBorder.isWinBelowStake());
        TheBorder.allReelsView.reInit();
        TheBorder.gameFlowController.start();
        TheBorder.keypadPlugin.show();
    }



}